import { useState } from 'react';

export default function Portfolio() {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Urban Beats EP',
      category: 'Music Production',
      image: 'https://public.readdy.ai/ai/img_res/85654ade79450b9fe2b8d7a880f30b97.jpg',
      description: 'Full EP production including recording, mixing, and mastering'
    },
    {
      id: 2,
      title: 'Brand Identity Package',
      category: 'Graphic Design',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20graphic%20designer%20working%20on%20brand%20identity%20design%20at%20computer%20workstation%2C%20creating%20logos%20and%20visual%20branding%20materials%2C%20modern%20creative%20workspace%20with%20design%20tools%20and%20color%20swatches%2C%20clean%20minimalist%20background%2C%20South%20African%20creative%20professional&width=800&height=600&seq=portfolio2&orientation=landscape',
      description: 'Complete brand identity with logo, business cards, and social media kit'
    },
    {
      id: 3,
      title: 'Podcast Series Mix',
      category: 'Audio Engineering',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20podcast%20host%20recording%20in%20modern%20podcast%20studio%20with%20professional%20microphone%20and%20headphones%2C%20engaging%20in%20conversation%2C%20contemporary%20broadcasting%20setup%20with%20acoustic%20treatment%2C%20warm%20studio%20lighting%2C%20authentic%20South%20African%20media%20production&width=800&height=600&seq=portfolio3&orientation=landscape',
      description: '12-episode podcast series with professional audio treatment'
    },
    {
      id: 4,
      title: 'Event Poster Design',
      category: 'Graphic Design',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20graphic%20designer%20creating%20vibrant%20event%20poster%20designs%20on%20computer%2C%20working%20with%20typography%20and%20colorful%20graphics%2C%20creative%20studio%20environment%20with%20design%20materials%20and%20inspiration%20boards%2C%20clean%20modern%20workspace%2C%20South%20African%20design%20professional&width=800&height=600&seq=portfolio4&orientation=landscape',
      description: 'Eye-catching promotional materials for local music event'
    },
    {
      id: 5,
      title: 'Artist Album Recording',
      category: 'Music Production',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20recording%20artist%20performing%20vocals%20in%20professional%20recording%20studio%20booth%20with%20microphone%20and%20pop%20filter%2C%20passionate%20musical%20performance%2C%20modern%20studio%20environment%20with%20soundproofing%20and%20professional%20lighting%2C%20authentic%20South%20African%20music%20recording%20session&width=800&height=600&seq=portfolio5&orientation=landscape',
      description: 'Full-length album production with vocal coaching'
    },
    {
      id: 6,
      title: 'Commercial Audio Mix',
      category: 'Post Production',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20sound%20engineer%20working%20at%20large%20professional%20mixing%20console%20in%20recording%20studio%2C%20adjusting%20audio%20levels%20and%20controls%2C%20focused%20on%20audio%20production%20work%2C%20modern%20studio%20environment%20with%20multiple%20monitors%20and%20professional%20equipment%2C%20authentic%20South%20African%20audio%20production%20professional&width=800&height=600&seq=portfolio6&orientation=landscape',
      description: 'Radio and TV commercial audio production and mixing'
    },
    {
      id: 7,
      title: 'Social Media Campaign',
      category: 'Graphic Design',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20content%20creator%20designing%20social%20media%20graphics%20on%20computer%2C%20creating%20engaging%20posts%20and%20marketing%20materials%2C%20modern%20creative%20workspace%20with%20multiple%20screens%20showing%20social%20media%20platforms%2C%20clean%20contemporary%20office%20environment%2C%20South%20African%20digital%20marketing%20professional&width=800&height=600&seq=portfolio7&orientation=landscape',
      description: 'Monthly social media content package for local business'
    },
    {
      id: 8,
      title: 'Live Performance Recording',
      category: 'Music Production',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Black%20African%20musicians%20performing%20live%20music%20on%20stage%20with%20instruments%20and%20microphones%2C%20energetic%20live%20performance%20with%20band%20members%2C%20concert%20venue%20with%20professional%20stage%20lighting%20and%20sound%20equipment%2C%20authentic%20South%20African%20live%20music%20scene%20and%20performance%20culture&width=800&height=600&seq=portfolio8&orientation=landscape',
      description: 'Multi-track live recording and post-production'
    }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <section id="portfolio" className="py-24 px-6 bg-gradient-to-b from-[#1a1a1a] to-[#0a0f1c]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <div className="text-[#00d9ff] text-sm font-semibold tracking-widest mb-4">RECENT WORK</div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-8">PROJECTS THAT SPEAK</h2>
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => setFilter('all')}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                filter === 'all' 
                  ? 'bg-[#00d9ff] text-black' 
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              All Projects
            </button>
            <button 
              onClick={() => setFilter('music')}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                filter === 'music' 
                  ? 'bg-[#ff6b35] text-white' 
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              Music Studio
            </button>
            <button 
              onClick={() => setFilter('design')}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                filter === 'design' 
                  ? 'bg-[#00d9ff] text-black' 
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              Graphic Design
            </button>
            <button 
              onClick={() => setFilter('post')}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                filter === 'post' 
                  ? 'bg-[#d4af37] text-black' 
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              Post Production
            </button>
          </div>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {filteredProjects.map((project) => (
            <div 
              key={project.id}
              className="group relative rounded-[24px] overflow-hidden cursor-pointer hover:transform hover:scale-105 transition-all duration-500"
            >
              <div className="w-full h-80">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300"></div>
              
              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-between">
                <div 
                  className="inline-block self-start px-4 py-1 rounded-full text-xs font-bold text-black"
                  style={{ backgroundColor: project.tagColor }}
                >
                  {project.tag}
                </div>
                
                <div>
                  <h3 className="text-white text-xl font-bold mb-2">{project.title}</h3>
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm">
                      <i className="ri-eye-line text-white text-xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button className="bg-[#ff6b35] text-black px-10 py-4 rounded-full hover:bg-[#ff8555] transition-all duration-300 font-bold text-lg whitespace-nowrap cursor-pointer">
            VIEW FULL PORTFOLIO
          </button>
        </div>
      </div>
    </section>
  );
}
